// Dock page-context: what the user has open when messaging ARON. Sent as
// `page_context` with each message; the backend injects it into the turn's
// context wrapper so "ta pozycja"/"ten kosztorys" resolves to the on-screen
// object. Matchers cover the hot DETAIL pages (entity + id); any other page
// still sends its raw path + query string, which is a useful hint on its own.
// Mirror of entityRoute.ts (route → entity instead of entity → route) — keep
// the two in sync when detail pages appear/move.

export interface PageContext {
  path: string;
  label?: string;
  entity?: string;
  entity_id?: string;
  search?: string;
}

const ID = "([0-9a-fA-F][0-9a-fA-F-]{7,35})";

const MATCHERS: Array<{ re: RegExp; label: string; entity: string }> = [
  { re: new RegExp(`^/estimating/${ID}`), label: "Wynik wyceny kosztorysu", entity: "Estimate" },
  { re: new RegExp(`^/projects/${ID}`), label: "Karta przedsięwzięcia", entity: "Project" },
  { re: new RegExp(`^/power-projects/${ID}`), label: "Projekt ZE (nN/SN)", entity: "PowerProject" },
  { re: new RegExp(`^/tenders/${ID}`), label: "Karta przetargu", entity: "Tender" },
  { re: new RegExp(`^/orders/${ID}`), label: "Karta zamówienia", entity: "Order" },
  { re: new RegExp(`^/requisitions/${ID}`), label: "Karta zapotrzebowania", entity: "Requisition" },
  { re: new RegExp(`^/protocols/${ID}`), label: "Protokół odbioru (POCK)", entity: "AcceptanceProtocol" },
  { re: new RegExp(`^/invoices/${ID}`), label: "Faktura podwykonawcy", entity: "ContractorInvoice" },
  { re: new RegExp(`^/finances/invoices-prz/${ID}`), label: "Faktura przychodowa (PRZ)", entity: "ClientInvoice" },
];

export function buildPageContext(pathname: string, search: string): PageContext | null {
  // The ARON page itself (and the root redirect) carries no useful "where is the
  // user" signal — send nothing rather than noise.
  if (!pathname || pathname === "/" || pathname.startsWith("/aron")) return null;
  const ctx: PageContext = { path: pathname.slice(0, 300) };
  if (search && search.length > 1) ctx.search = search.slice(0, 500);
  for (const m of MATCHERS) {
    const hit = m.re.exec(pathname);
    if (hit) {
      ctx.label = m.label;
      ctx.entity = m.entity;
      ctx.entity_id = hit[1];
      break;
    }
  }
  return ctx;
}
